import {replace, push} from "react-router-redux";
import {ajax, removePath, checkResponseOKStatus} from "../../common/utils";
import {gotoStep} from "./joinActions";
import {setDirty} from "../common/commonActions";
import {handlePaymentRedirect} from "../pay/paymentActions";
import {JoinSteps, FetchingTypes} from '../../common/constants';
import {buildSubscriptionFromState} from '../../common/subscription';
import {fetchingData, dataFetched, errorFetching} from '../common/fetchingActions';
import {CIM_NOT_ENABLED, CIM_NOT_ENABLED_ERROR_CODE, SUBSCRIPTION_EXISTS_ERROR, SUBSCRIPTION_EXISTS_ERROR_MESSAGE, INVALID_USER_AUTHENTICATION_ERROR_CODE} from '../../common/constants';

export function submitSubscription(){
    return function(dispatch, getState){
        const state = getState();
        if (state.signupData.isAddSubscription)
            dispatch(addSubscription());
        else
            dispatch(createSubscription());
    }
}

function createSubscription(){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/WebStoreService.createSubscription';
        const subscriptionData = JSON.stringify(buildSubscriptionFromState(state));
        const paymentMethod = state.signupData.selectedData.selectedMethod;
        const data = {
            farmKey: state.staticData.farmKey,
            seasonKey: state.staticData.seasonKey,
            memberKey: state.memberDetails.key,
            subscription: subscriptionData,
            paymentMethod: paymentMethod
        };
        dispatch(fetchingData(FetchingTypes.SUBMIT));
        return ajax(fetchUrl, data)
            .then(response => {
                if (response.message && response.message === "Cannot retrieve the pickup site"){
                    throw ({"message": "Cannot retrieve the pickup site, Please refresh your browser and try again"});
                }
                if (response.message && (response.message === CIM_NOT_ENABLED_ERROR_CODE || response.message === INVALID_USER_AUTHENTICATION_ERROR_CODE))
                    throw ({"message": CIM_NOT_ENABLED});
                if (response.message && response.message === SUBSCRIPTION_EXISTS_ERROR) {
                    dispatch(setDirty(false));
                    throw ({message: SUBSCRIPTION_EXISTS_ERROR_MESSAGE});
                }
                dispatch(handlePaymentRedirect(response, paymentMethod, gotoStep(JoinSteps.THANK_YOU)));
            })
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}

function addSubscription(){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/WebStoreService.addSubscription';
        const subscription = buildSubscriptionFromState(state);
        const paymentMethod = state.signupData.selectedData.selectedMethod;
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey: state.summary.key,
            shareItems: JSON.stringify(subscription.shareItems),
            shareItemQuantities: JSON.stringify(subscription.shareItemQuantities),
            shareItemSchedules: JSON.stringify(subscription.shareItemSchedules),
            waitListItems: JSON.stringify(subscription.waitListItems),
            paymentPlan: subscription.paymentPlan,
            coupon: subscription.coupon,
            paymentMethod: paymentMethod
        };
        dispatch(fetchingData(FetchingTypes.SUBMIT));
        return ajax(fetchUrl, data)
            .then(response => {
                dispatch(handlePaymentRedirect(response, paymentMethod, gotoStep(JoinSteps.THANK_YOU)));
            })
            .catch(error => {
                //Ignore the error as in most cases it is a false error
                console.error(error);
                dispatch(handlePaymentRedirect({}, paymentMethod, gotoStep(JoinSteps.THANK_YOU)));
            })
    }
}

export function completeSubscription(){
    return function(dispatch, getState){
        const fetchUrl = '/dispatcher/SignupService.completeAuthorizeDotNetPreapprovalSignup';
        const state = getState();
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            postAction: state.checkout.postActionKey
        };
        dispatch(fetchingData(FetchingTypes.SUBMIT));
        return ajax(fetchUrl, data)
            .then(json => {
                checkResponseOKStatus(json);
                dispatch(setDirty(false));
                dispatch(replace(removePath('/payments')));
                dispatch(gotoStep(JoinSteps.THANK_YOU));
                dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(replace(removePath('/payments')));
                dispatch(dataFetched());
                dispatch(errorFetching(error));
            })
    }
}



// WEBPACK FOOTER //
// ./src/actions/join/joinPayActions.js